import { useEffect, useRef } from "react";

function useMuseAnimations({
  screenId,
  setScanLinePosition,
  setFaceZoomed,
  setShowFaceScanLine,
  setFaceScanLinePosition,
  setCurrentOutfit,
  outfitImages,
  setTypewriterText,
  setShowLargeS,
  fullText,
}: any) {
  const animationRefs = useRef<any>({
    scan: null,
    face: null,
    outfit: null,
    typewriter: null,
  });

  const cleanupAnimations = () => {
    Object.values(animationRefs.current).forEach((ref: any) => {
      if (typeof ref === "number") {
        cancelAnimationFrame(ref);
      } else if (ref) {
        clearTimeout(ref);
        clearInterval(ref);
      }
    });
    animationRefs.current = {
      scan: null,
      face: null,
      outfit: null,
      typewriter: null,
    };
  };

  useEffect(() => {
    cleanupAnimations();

    switch (screenId) {
      case "body": {
        const startTime = Date.now();
        const duration = 3000;

        const animateScanLine = () => {
          const elapsed = Date.now() - startTime;
          const progress = Math.min(elapsed / duration, 1);
          setScanLinePosition(progress * 100);
          if (progress < 1) {
            animationRefs.current.scan = requestAnimationFrame(animateScanLine);
          }
        };

        animationRefs.current.scan = requestAnimationFrame(animateScanLine);
        break;
      }

      case "face": {
        setFaceZoomed(false);
        setShowFaceScanLine(false);
        setFaceScanLinePosition(0);

        animationRefs.current.face = setTimeout(() => {
          setFaceZoomed(true);

          setTimeout(() => {
            setShowFaceScanLine(true);

            const startTime = Date.now();
            const duration = 6000; // ✅ Total 6s (3s for each direction)

            const animateFaceScanLine = () => {
              const elapsed = Date.now() - startTime;
              const progress = Math.min(elapsed / duration, 1);

              setFaceScanLinePosition(
                progress <= 0.5 ? progress * 2 * 100 : (2 - progress * 2) * 100
              );

              if (progress < 1) {
                animationRefs.current.face =
                  requestAnimationFrame(animateFaceScanLine);
              }
            };

            animationRefs.current.face =
              requestAnimationFrame(animateFaceScanLine);
          }, 2500); // Delay after zoom
        }, 800); // Delay before zoom
        break;
      }

      case "sizeFit": {
        setCurrentOutfit(0);
        animationRefs.current.outfit = setInterval(() => {
          setCurrentOutfit((prev: any) => (prev + 1) % outfitImages.length);
        }, 1500);
        break;
      }

      case "ready": {
        setShowLargeS(false);
        setTypewriterText("");

        animationRefs.current.typewriter = setTimeout(() => {
          setShowLargeS(true);
          setTimeout(() => {
            let currentIndex = 0;
            const typeNextChar = () => {
              if (currentIndex < fullText.length) {
                setTypewriterText(fullText.slice(0, currentIndex + 1));
                currentIndex++;
                animationRefs.current.typewriter = setTimeout(typeNextChar, 30);
              }
            };
            typeNextChar();
          }, 1000);
        }, 800);
        break;
      }

      default:
        break;
    }

    return cleanupAnimations;
  }, [screenId]);
}

export default useMuseAnimations;
